import * as React from 'react';
import {useEffect, useState} from "react";
import { FilterContext } from './FilterContext';

type Props = {
    children: React.ReactNode;
}



export const CENTRUM_PRAHY_SOURADNICE = { lat: "50.08804", lng: "14.42076" };

export const FilterProvider : React.FC<Props> = ({ children }) => {
    const [filterParams, setFilterParams] = useState<any>({
        sort: "distance",
        openingHours: "anytime",
        lat: CENTRUM_PRAHY_SOURADNICE.lat,
        lng: CENTRUM_PRAHY_SOURADNICE.lng,
    });

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const params = {};
        
        for (let [key, value] of searchParams) {
            // @ts-ignore
            params[key] = value;
        }

        setFilterParams((prevState : any) => ({
            ...prevState,
            ...params,
        }));

    }, []);

    useEffect(() => {
        const searchParams = new URLSearchParams(filterParams);
        const queryString = searchParams.toString();
        window.history.replaceState(null, '', `?${queryString}`);
        updateLocalStorageServices( searchParams );
    }, [filterParams]);

    const updateLocalStorageServices = ( searchParams : URLSearchParams ) => {

        const filteredServices = searchParams.get('services');
        if ( filteredServices ) {
            localStorage.setItem("saved__services", JSON.stringify(filteredServices.split(',')));
        } else {
            localStorage.removeItem("saved__services");
        }

    }

    // Neappenduje pokud se klíč shoduje, pokud se předchozí hodnota rovná nové, smaže
    const updateFilterParams = (newParams : any) => {


        setFilterParams((prevState : any) => {
            const updatedParams : any = { ...prevState };
            if(newParams?.filter?.includes("-")){

                if(!updatedParams.filter){
                    updatedParams.filter = newParams.filter;
                    return updatedParams;
                }

                const matchIndex = updatedParams.filter.split(",").findIndex((value : string) => value.split("-")[0] === newParams.filter.split("-")[0]);

                if(matchIndex !== -1){
                    if(updatedParams.filter.includes(newParams.filter)){
                        const filterArray = updatedParams.filter.split(",");
                        filterArray[matchIndex] = "";
                        updatedParams.filter = filterArray.filter(Boolean).join(",");
                        if(updatedParams.filter.length === 0){
                            delete updatedParams.filter;
                        }
                        return updatedParams;
                    }
                    const filterArray = updatedParams.filter.split(",");
                    filterArray[matchIndex] = newParams.filter;
                    updatedParams.filter = filterArray.join(",");
                    return updatedParams;
                }
                else {
                   const temporaryArray = updatedParams.filter.split(",");
                   temporaryArray.push(newParams.filter);
                   updatedParams.filter = temporaryArray.join(",");
                }

                return updatedParams;
            }
            else {
                for (let [key, value] of Object.entries(newParams)) {
                    if(updatedParams[key] === undefined) {
                        updatedParams[key] = value;
                    }
                    else if(updatedParams[key] === value){
                        delete updatedParams[key];
                    }
                    else if(updatedParams[key] !== value){
                        updatedParams[key] = value;
                    }
                }
                return updatedParams;
            }
        });
    };

    const updateVozidloParams = (newParams : any) => {
        setFilterParams((prevState : any) => {
            const updatedParams : any = { ...prevState };
            for (let [key, value] of Object.entries(newParams)) {

                if(updatedParams[key] === null || updatedParams[key] === "null" || !value) {
                    delete updatedParams[key];
                }
                else if(updatedParams[key] === undefined) {
                    updatedParams[key] = value;
                }
                else if(typeof updatedParams[key] === "string") {
                    updatedParams[key] = value;
                }
                else if(Array.isArray(value)) {
                    if(value.length === 0){
                        delete updatedParams[key];
                    }
                    else {
                        updatedParams[key] = value.map(obj => obj.value).join(',');
                    }
                }
            }

            return updatedParams;
        })
    }

    const updateMultiFilterParams = (newParams : any) => {

        setFilterParams((prevState : any) => {
            const updatedParams : any = { ...prevState };

            for (let [key, value] of Object.entries(newParams)) {
                if(!value) delete updatedParams[key];
                if(updatedParams[key] === null || updatedParams[key] === "null") {
                    delete updatedParams[key];
                }
                else if(Array.isArray(value)) {
                    if(value.length === 0){
                        delete updatedParams[key];
                    }
                    else {
                        updatedParams[key] = value.map((data) => data.value).join(",");
                    }

                }

                else if(typeof value === "string") {
                    updatedParams[key] = value;
                }
            }

            return updatedParams;
        })
    }

    // appenduje pokud se klíč shoduje, taktéž smaže pokud se klikne na stejnou hodnotu
    const appendFilterParams = (newParams : any) => {
        setFilterParams((prevState : any) => {
            const updatedParams : any = { ...prevState };
            for (let [key, value] of Object.entries(newParams)) {

                 if (updatedParams[key] === undefined) {
                    updatedParams[key] = value;
                } else if (typeof updatedParams[key] === 'string') {
                    const arr = updatedParams[key].split(',').filter((item : any) => item !== value);
                    if (arr.length === 0) {
                        delete updatedParams[key];
                    } else {
                        const matchedItem = (updatedParams[key].split(',').filter((item : any) => item === value));
                        if(matchedItem.length === 0){
                            updatedParams[key] += "," + value;
                        }
                        else {
                            updatedParams[key] = (updatedParams[key].split(',').filter((item : any) => item !== value)).join(',');
                        }
                    }
                }
            }

            return updatedParams;
        });
    };

    const setNewFilterParams = (filter : any, change : any) => {
        setFilterParams((prev : any) => {
            const { sort, openingHours, lat, lng } = prev;

            const newParamsObject : any = { sort, openingHours, lat, lng };

            const filters = filter.split('&');

            for (const localFilter of filters) {
                const splited = localFilter.split('=');
                newParamsObject[splited[0]] = splited[1];
            }


            if(change){
                for (let [key, value] of Object.entries(change)) {
                    if(!value) delete newParamsObject[key];
                    if(newParamsObject[key] === null || newParamsObject[key] === "null") {
                        delete newParamsObject[key];
                    }
                    else if(Array.isArray(value)) {
                        if(value.length === 0){
                            delete newParamsObject[key];
                        }
                        else {
                            newParamsObject[key] = value.map((data) => data.value).join(",");
                        }

                    }

                    else if(typeof value === "string") {
                        newParamsObject[key] = value;
                    }
                }
            }

            return newParamsObject;
        })
    }

    return (
        <FilterContext.Provider value={{ filterParams, updateFilterParams, updateMultiFilterParams, appendFilterParams, updateVozidloParams, setNewFilterParams }}>
            {children}
        </FilterContext.Provider>
    );
};